
import { defineComponent, computed } from "vue";
import useStore from "@/composables/useStore";
import pick from "lodash.pick";
import DiamondShapeButton from "@/components/DiamondShapeButton.vue";
import { DiamondShapes } from "@/types/types";
import useDiamondShapeImageMap from "@/composables/useDiamondShapeImageMap";
import { useI18n } from "vue-i18n";

export default defineComponent({
    name: "DiamondShapeSelect",
    components: {
        DiamondShapeButton
    },
    setup() {
        const store = useStore();

        const diamondShapeImageMap = useDiamondShapeImageMap();

        const selectedShape = computed(() => store.state.userSelection.shape);

        const availableDiamonds = computed(() => store.state.availableDiamonds);
        const availableShapes = computed(() => {
            return [
                ...new Set(
                    availableDiamonds.value.map(diamond => diamond.shape)
                )
            ];
        });

        const shapes = computed(() =>
            pick(diamondShapeImageMap, availableShapes.value)
        );

        function handleDiamondShapeSelect(shape: DiamondShapes) {
            store.actions.setSelectedShape(shape);
        }

        return {
            ...useI18n(),
            selectedShape,
            shapes,
            handleDiamondShapeSelect
        };
    }
});
